import { makeStyles } from "@mui/styles";

const useStyles: any = makeStyles((theme: any) => ({
  buttonStyle: {
    height: "40px",
    borderRadius: "4px",
    backgroundImage: theme.gradiants.button,
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "normal",
    color: "#fdfdfe",
    margin: 0,
    marginBottom: "15px",
  },
  addButtonContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    paddingTop:'16px !important',
  },

  section: {
    padding: "1rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
    height: "92%",
    minHeight: 480,
    boxSizing: "border-box",
  },
  sectionCompact: {
    padding: "1rem",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "stretch",
    height: 397,
    minHeight: 397,
    overflow: "hidden",
    boxSizing: "border-box",
  },
  sectionStacked: {
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    height: "auto",
    boxSizing: "border-box",
  },

  sectionTitle: {
    fontWeight: "bold",
    marginBottom: "10px",
    borderBottom: "1px rgb(87, 69, 92) solid",
  },
  fieldGridContainer: {
    "&>button": {
      width: "144px",
    },
    display: "flex",
    justifyContent: "flex-end",
    padding: "20px 0",
    marginBottom: "30px",
  },
  siteDetailsHeader: {
    padding: "4px 20px",
    boxShadow: "0px 5px 5px 0px rgba(214, 206, 214, 1)",
    boxSizing: "border-box",
    fontWeight: "bold",
    marginBottom: "10px",
  },
  saveButtonStyle: {
    width: "24%",
    color: "white",
    backgroundColor: "#331e38",
    marginLeft: "20px",
  },
  editSiteTitle: {
    boxSizing: "border-box",
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
  fieldTitleGrid: {
    alignSelf: "center",
  },

  fieldBtnGrid: {
    display: "flex",
    justifyContent: "space-evenly",
  },

  filedTitle: {
    fontWeight: "bold",
    fontSize: "16px",
  },

  textField: {
    width: "100%",
    height: "4rem",
    lineHeight: "0",
    "&>input": {
      border: "1px solid gray",
      borderRadius: "3px",
      fontSize: "20px",
    },
  },

  fieldInputGrid: {
    flexDirection: "unset",
  },

  textFieldValue: {
    width: "6rem",
  },

  selector: {
    width: "100%",
    border: "1px solid gray",
    borderRadius: "5px",
    padding: "10px 1rem",
  },

  bootTitle: {
    fontWeight: "bold",
    fontSize: "16px",
  },

  editDeviceWrapper: {
    height: "74vh",
    width: "100%",
  },

  bootWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
  },

  paperPadding: {
    padding: "20px 21px",
    maxHeight: "calc(100% - 130px)",
    display: "flex",
    flexFlow: "column nowrap",
    minHeight: "200px",
  },
  adormentsStyle: {
    fontSize: "20px",
  },
  searchBox: {
    marginBottom: "15px",
    width: "25%",
    "&>input": {
      fontSize: "16px",
    },
  },
  tableHead: {
    height: "45px",
    backgroundColor: "rgb(239, 239, 242, 0.48)",
  },
  headCells: {
    border: "none",
    padding: "0 15px",
    color: theme.tables.headerCell.color,
    fontWeight: theme.tables.headerCell.fontWeight,
    lineHeight: theme.tables.headerCell.lineHeight,
    letterSpacing: theme.tables.headerCell.letterSpacing,
    backgroundColor: theme.tables.headerCell.backgroundColor,
    textTransform: theme.tables.headerCell.textTransform,
    fontFamily: theme.tables.headerCell.fontFamily,
    height: 45,
    fontSize: 13,
  },
  rowCell: {
    color: theme.tables.tableCell.color,
    fontSize: theme.tables.tableCell.fontSize,
    fontFamily: theme.tables.tableCell.fontFamily,
    padding: theme.tables.tableCell.padding,
  },

  consoleContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "stretch",
    alignItems: "stretch",
    alignSelf: "stretch",
    width: "58%",
    minHeight: 0,
    overflow: "hidden",
    "& .terminal-base": {
      minWidth: "unset !important",
      minHeight: "0 !important",
      width: "100% !important",
      flex: 1,
      height: "100% !important",
      maxHeight: "100% !important",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
    },
    "& .terminal-base > div": {
      flex: 1,
      minHeight: "0 !important",
      width: "100% !important",
      height: "100% !important",
      maxHeight: "100% !important",
      display: "flex",
      flexDirection: "column",
      boxSizing: "border-box",
    },
    "& .terminal-base > div > div": {
      width: "100% !important",
      maxWidth: "100% !important",
      boxSizing: "border-box",
    },
    "& .terminal-base > div > div:last-child": {
      flex: "1 1 auto !important",
      minHeight: 0,
      height: "auto !important",
      maxHeight: "none !important",
      display: "flex",
      flexDirection: "column",
    },
    "& .terminal-base > div > div:last-child > div": {
      flex: "1 1 auto !important",
      width: "100% !important",
      height: "100% !important",
    },
    "& .terminal-base > div > div:last-child > div > div": {
      width: "100% !important",
      maxWidth: "100% !important",
      boxSizing: "border-box",
    },
    "&>div": {
      flex: 1,
      width: "100%",
      maxWidth: "100%",
      height: "100%",
      maxHeight: "none",
    },
  },
  consoleSurface: {
    width: "100%",
    height: "100%",
    minHeight: 0,
  },

  consoleContainerStacked: {
    display: "flex",
    justifyContent: "flex-start",
    width: "100%",
    height: 320,
    marginTop: 16,
    overflow: "hidden",
    "& .terminal-base": {
      minWidth: "unset",
    },
    "&>div": {
      maxWidth: "100%",
      maxHeight: "100%",
    },
  },

  siteDetailsForm: {
    width: "40%",
    minWidth: 0,
    height: "90%",
    overflowX: "hidden",
    overflowY: "auto",
    "&>label": {
      minWidth: "125px",
      fontSize: "12px",
      fontWeight: "bold",
    },
    "&>div": {
      padding: "0 6px",
      boxSizing: "border-box",
      fontSize: "12px",
    },
  },
  siteDetailsFormStacked: {
    width: "100%",
    minWidth: 0,
    height: "auto",
    overflowX: "hidden",
    overflowY: "visible",
    "&>label": {
      minWidth: "125px",
      fontSize: "12px",
      fontWeight: "bold",
    },
    "&>div": {
      padding: "0 6px",
      boxSizing: "border-box",
      fontSize: "12px",
    },
  },
  deviceInfoTitle: {
    display: "flex",
    width: "100%",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    padding: "8px 6px",
    boxShadow: "0px 6px 7px 0px rgba(214, 206, 214, 1)",
    marginBottom: "10px",
    alignItems: "center",
  },
  headContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  blueFilter: {
    fill: "#1976d2",
  },
  filterStyle: {
    marginLeft: "10px",
  },
  arrowIcon: {
    fontSize: "91px",
    transform: "rotate(90deg)",
  },
  noContentContainer: {
    display: "flex",
    flex: "1",
    boxShadow: "0 2px 5px -5px rgba(180, 175, 203, 0.63)",
    backgroundColor: "#fefefe",
    justifyContent: "center",
    alignItems: "center",
    padding: 0,
    width: "calc(100% - 60px)",
    height: "calc(100% - 130px)",
    alignSelf: "center",
    marginTop: "30px",
  },
  grayOval: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "136px",
    height: "136px",
    backgroundColor: "rgba(170, 162, 170, 0.1)",
    borderRadius: "50%",
  },
  connectionStatusInner: {
    alignItems: "center",
    width: "100%",
    minWidth: 0,
  },
  onlineStatusText: {
    "& input": {
      color: "#2e7d32 !important",
      WebkitTextFillColor: "#2e7d32 !important",
      opacity: "1 !important",
      fontWeight: 700,
      cursor: "default",
    },
  },
  offlineStatusText: {
    "& input": {
      color: "#d32f2f !important",
      WebkitTextFillColor: "#d32f2f !important",
      opacity: "1 !important",
      fontWeight: 700,
      cursor: "default",
    },
  },
  firmwareVersionRow: {
    position: "relative",
  },
  firmwareVersionInner: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    minWidth: 0,
  },
  firmwareVersionInline: {
    display: "inline-flex",
    alignItems: "center",
    flex: "0 1 auto",
    minWidth: 0,
    maxWidth: "100%",
  },
  firmwareVersionText: {
    // Match AdvancedInputField disabled InputBase (Disconnected Date)
    fontSize: "1rem",
    lineHeight: 1.4375,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 400,
    letterSpacing: "0.00938em",
    color: "rgba(0, 0, 0, 0.38)",
    cursor: "default",
    userSelect: "none",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  firmwareReleaseNotesHelpBtn: {
    color: "#5a4a5c",
    padding: "2px",
    marginLeft: "2px",
    flex: "0 0 auto",
  },
  firmwareUpdateState: {
    flex: "0 0 auto",
    whiteSpace: "nowrap",
    fontSize: "0.9rem",
    color: "#4b1c46",
    fontWeight: 600,
    marginLeft: "4px",
  },
  firmwareVersionActions: {
    display: "inline-flex",
    alignItems: "center",
    flex: "0 0 auto",
    gap: "2px",
    marginLeft: "auto",
  },
  firmwareVersionMeasure: {
    position: "absolute",
    left: 0,
    top: 0,
    visibility: "hidden",
    pointerEvents: "none",
    height: 0,
    overflow: "hidden",
    whiteSpace: "nowrap",
    display: "inline-flex",
    alignItems: "center",
  },
  firmwareUpdatingSpinnerWrap: {
    display: "inline-flex",
    alignItems: "center",
    margin: "0 4px",
  },
  firmwareUpdatingSpinner: {
    color: "#4b1c46",
  },
  firmwareUpgradeBtn: {
    color: "#1976d2",
    padding: "4px",
  },
  firmwareCancelBtn: {
    color: "#d32f2f",
    padding: "4px",
  },
  firmwareForceBtn: {
    color: "#ed6c02",
    padding: "4px",
  },
  firmwareHistoryBtn: {
    color: "#5a4a5c",
    padding: "4px",
  },
  firmwareMismatch: {
    color: "#ed6c02 !important",
    opacity: "1 !important",
    fontWeight: 600,
  },
  firmwareHistoryLoading: {
    display: "flex",
    justifyContent: "center",
    padding: "16px 0",
  },
  firmwareActionDetail: {
    marginTop: "16px",
    outline: "none",
    scrollMarginTop: "12px",
  },
  firmwareActionSummary: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginBottom: "12px",
    padding: "10px 12px",
    backgroundColor: "#f7f5f8",
    borderRadius: "4px",
  },
  firmwareActionSummaryLine: {
    fontSize: "0.9rem",
    color: "rgba(0, 0, 0, 0.8)",
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  firmwareActionDetailPre: {
    margin: 0,
    maxHeight: "240px",
    overflow: "auto",
    backgroundColor: "#f7f5f8",
    borderRadius: "4px",
    padding: "10px",
    fontSize: "0.75rem",
  },
  firmwareLogsSection: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    marginTop: "16px",
    padding: "10px 0 4px",
    width: "100%",
    borderBottom: "1px solid #ccc",
  },
  firmwareLogsTitle: {
    fontSize: "0.85rem",
    fontWeight: 600,
    color: "rgba(0, 0, 0, 0.7)",
  },
  firmwareLogsList: {
    maxHeight: "none",
    overflow: "visible",
    backgroundColor: "#f7f5f8",
    borderRadius: "4px",
    padding: "8px 10px",
  },
  firmwareLogLine: {
    fontSize: "0.8rem",
    fontFamily: "Consolas, Monaco, monospace",
    color: "rgba(0, 0, 0, 0.8)",
    lineHeight: 1.45,
    wordBreak: "break-word",
  },
  firmwareUpgradeDialogTitle: {
    padding: "20px 24px 8px",
  },
  firmwareUpgradeDialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    padding: "12px 24px 8px !important",
  },
  firmwareUpgradeCurrentLabel: {
    fontSize: "0.95rem",
    color: "rgba(0, 0, 0, 0.7)",
    lineHeight: 1.5,
  },
  firmwareVersionWithHelp: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  firmwareUpgradeSelectRow: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    width: "100%",
  },
  firmwareUpgradeSelect: {
    flex: "1 1 auto",
    minWidth: 0,
  },
  firmwareUpgradeDialogActions: {
    padding: "16px 24px 20px",
    gap: "8px",
  },
  firmwareUpgradeCancelBtn: {
    textTransform: "none",
    color: "#5a4a5c",
  },
  firmwareUpgradeActionBtn: {
    textTransform: "none",
    height: "40px",
    minWidth: "160px",
    borderRadius: "4px",
    backgroundColor: "#4b1c46",
    backgroundImage: "none",
    color: "#ffffff",
    boxShadow: "none",
    margin: 0,
    "&:hover": {
      backgroundColor: "#3a1536",
      backgroundImage: "none",
      boxShadow: "none",
    },
    "&.Mui-disabled": {
      backgroundColor: "#c4b8c6",
      backgroundImage: "none",
      color: "#ffffff",
    },
  },
  firmwareProgressDialogTitle: {
    padding: "20px 24px 8px",
  },
  firmwareProgressDialogContent: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "12px 24px 8px !important",
  },
  firmwareProgressSubtitle: {
    fontSize: "0.95rem",
    color: "rgba(0, 0, 0, 0.7)",
  },
  firmwareProgressBar: {
    height: "6px",
    borderRadius: "100px",
  },
  firmwareProgressMetaRow: {
    display: "flex",
    justifyContent: "space-between",
    fontSize: "0.85rem",
    color: "rgba(0, 0, 0, 0.6)",
  },
  firmwareProgressDialogActions: {
    padding: "16px 24px 20px",
  },
}));
export default useStyles;
